module.exports = __webpack_public_path__ + "media/src/img/mob-frame-lh-1812fe51d83596a6f6ac9b700f4e0037.png";